export type AutoSaveTickAction = 'seed' | 'skip' | 'save';

/**
 * Decide what the auto-save interval should do with the current project
 * snapshot.
 *
 * - `lastSaved === null` — no baseline recorded yet for this session: the
 *   project was just loaded, so any difference is hydration/engine-sync
 *   noise, not a user edit. Record the baseline, do NOT save (a save would
 *   bump the backend `updated_at`, i.e. Cabinet's "Last Modified", on every
 *   open).
 * - `lastSaved === ''` — explicit force-save trigger (part rename, material
 *   change, visibility toggle clear the baseline to persist on next tick).
 * - otherwise save only when the snapshot actually differs.
 */
export function autoSaveTickAction(
  snapshot: string,
  lastSaved: string | null,
): AutoSaveTickAction {
  if (lastSaved === null) return 'seed';
  if (snapshot === lastSaved) return 'skip';
  return 'save';
}
